// extracted by mini-css-extract-plugin
export default {"after":"_3OtTFkmEZtiTwAhqOZgk_o","scrollStyle":"_3WKgsXxwuFP7AmnzQVUfBD"};